/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log("Container ———————— ↓");
      console.log(container);
      console.log("Variant —————————— ↓");
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log("Cart ———————————— ↓");
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    console.log("theme:cart:init");
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener("theme:scroll", (e) => {
    console.log(e);
  });
  document.addEventListener("theme:scroll:up", (e) => {
    console.log(e);
  });
  document.addEventListener("theme:scroll:down", (e) => {
    console.log(e);
  });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener("theme:resize", (e) => {
    console.log(e);
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

// fixed header
$(window).scroll(function () {
  if ($(this).scrollTop() > 150) {
    $(".theme__header").addClass("fixed");
  } else {
    $(".theme__header").removeClass("fixed");
  }
});

// upsell-collection-slider
$(".upsell-collection-slider").flickity({
  contain: true,
  wrapAround: false,
  draggable: true,
  dragClickables: true,
  pageDots: false,
  arrowShape: "M 10, 50 L 60, 100 L 65, 95 L 20, 50 L 65, 5 L 60, 0 Z",
});

// upsell-product-slider
$(".upsell-product-slider").flickity({
  contain: true,
  wrapAround: false,
  draggable: true,
  dragClickables: true,
  pageDots: false,
  arrowShape: "M 10, 50 L 60, 100 L 65, 95 L 20, 50 L 65, 5 L 60, 0 Z",
});

// top-brand-item-slider
$(".brand-item-slider").flickity({
  contain: true,
  wrapAround: false,
  pageDots: false,
  arrowShape: "M 10, 50 L 60, 100 L 65, 95 L 20, 50 L 65, 5 L 60, 0 Z",
});

// custom-pro-slider
$(".custom-pro-slider").flickity({
  contain: true,
  wrapAround: false,
  pageDots: true,
  prevNextButtons: false,
});

// main-collection-banner
$(".main-collection-banner").flickity({
  contain: true,
  wrapAround: false,
  pageDots: true,
  prevNextButtons: false,
  autoPlay: 4000,
});

// store-image-slider
$(".store-image-slider").flickity({
  contain: true,
  wrapAround: false,
  pageDots: true,
  prevNextButtons: false,
});

// brand-page
$('.brand-letter li a[href^="#"]').on("click", function (e) {
  var target = this.hash,
    $target = $(target);
  $(this).parents(".brand-letter").find("ul li a").removeClass("active");
  $(this).addClass("active");

  var headerHeight = $(".theme__header").height();
  $("html, body")
    .stop()
    .animate(
      {
        scrollTop: $target.offset().top - headerHeight,
      },
      500,
      "swing",
      function () {
        window.location.hash = target;
      }
    );
});

// enquiry form
// EbizIndia 27 Oct 2026: enquiry guard. The form only exists on product pages; elsewhere
// this code used to stop with "Cannot set properties of null". Each part now checks first.

var enquiryModal = document.getElementById("enquiryModal");
var enquirybtn = document.getElementById("enquiryBtn");
var closebtn = document.getElementsByClassName("close-btn")[0];

if (enquiryModal && enquirybtn) {
  enquirybtn.onclick = function(e) {
    e.preventDefault();
    enquiryModal.style.display = "block";
    document.documentElement.setAttribute("data-scroll-locked", "");
    document.body.style.overflow = "hidden";
  }

  if (closebtn) {
    closebtn.onclick = function() {
      enquiryModal.style.display = "none";
      document.documentElement.removeAttribute("data-scroll-locked");
      document.body.style.overflow = "auto";
    }
  }

  window.onclick = function(event) {
    if (event.target == enquiryModal) {
      enquiryModal.style.display = "none";
      document.documentElement.removeAttribute("data-scroll-locked");
      document.body.style.overflow = "auto";
    }
  }
}

// Purpose inquiry field
const customSelect = document.querySelector('.custom-select');
const selectText = customSelect ? customSelect.querySelector('.custom-select span') : null;
const inquiryOptions = document.querySelectorAll('.select-option-list li');
const hiddenSelect = document.querySelector('.enPurpose');

if (customSelect && selectText && hiddenSelect) {
  customSelect.addEventListener('click', () => {
    customSelect.classList.toggle("open");
  });

  for (const option of inquiryOptions) {
    option.addEventListener('click', e => {
      const selectedValue = option.textContent;
      inquiryOptions.forEach(opt => opt.classList.remove('active'));
      option.classList.add('active');

      // Update the select text with the clicked option's text
      selectText.textContent = selectedValue;
      hiddenSelect.value = selectedValue;

      setTimeout(() => {
        customSelect.classList.remove("open");
      }, 300); // Adjust the timeout delay if needed

      const changeEvent = new Event('change', { bubbles: true });
      hiddenSelect.dispatchEvent(changeEvent);
    });
  }

  // Sync hidden select's value with the custom select text
  hiddenSelect.addEventListener('change', () => {
    const selectedValue = hiddenSelect.value;
    selectText.textContent = selectedValue;
  });
}
